export const remittanceFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SEARCH_BY'],
  },
  // {
  //   type: 'startDate',
  //   key: 'start_date',
  //   placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['POLICY_EFFECTIVITY_DATE'],
  // },
  {
    type: 'endDate',
    key: 'end_date',
  },
  {
    type: 'multiSelect',
    key: 'insured_name',
    placeholder: 'Insurer',
    optionsKey: 'partnerList',
  },
  {
    type: 'multiSelect',
    key: 'source',
    optionsKey: 'lead_types',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SORUCE_TYPE'],
  },
];

export const remittanceMoreFilters = (translations: any) => [
  {
    type: 'createdDate',
    key: 'created_date'
  },
  {
    type: 'select',
    key: 'remittance_type',
    optionsKey: 'remittance_type',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_TYPE'],
    useCustomValueContainer: true,
  },
  {
    type: 'multiSelect',
    key: 'status',
    optionsKey: 'remittance_status',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_STATUS'],
    showWhen: {
      key: 'remittance_type',
      value: '__ANY__'
    }
  },
  {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    roleRestricted: true,
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'user_filter_type',
    optionsKey: 'user_filter_type',
    placeholder: 'Assigned to Role',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'user_filter_type',
      value: '__ANY__'
    }
  },
  {
    type: 'select',
    key: 'payout_payment_status',
    optionsKey: 'payout_payment_status',
    placeholder: translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['PAYMENT_STATUS'],
    useCustomValueContainer: true,
  },
];

export const leadListFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder:
      'Search by Policy No, Customer Mobile, Insurance ID or Customer Name',
  },
  {
    type: 'endDate',
    key: 'end_date',
  },
  {
    type: 'multiSelect',
    key: 'insured_name',
    optionsKey: 'partnerList',
    placeholder: 'Insurer'
  },
  {
    type: 'multiSelect',
    key: 'source',
    optionsKey: 'lead_types',
    placeholder: 'Source Type'
  }
];

export const leadListMoreFilters = (translations: any) => [
  {
    type: 'createdDate',
    key: 'created_date'
  },
  {
    type: 'select',
    key: 'payment_status',
    optionsKey: 'payment_status',
    placeholder: 'Payment Status',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'insurance_type',
    optionsKey: 'insurance_type',
    placeholder: 'Insurance Type',
    useCustomValueContainer: true,
  },
  {
    type: 'multiSelect',
    key: 'payment_method',
    optionsKey: 'payment_method',
    placeholder: 'Payment Method'
  },
  {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
    roleRestricted: true,
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    roleRestricted: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
]

export const paymentFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: 'Search by Policy No, Customer...',
  },
  {
    type: 'select',
    key: 'insured_id',
    optionsKey: 'insurerList',
    placeholder: 'Insurer Name',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'payment_due',
    optionsKey: 'payment_due_in',
    placeholder: 'Payment Due In',
    useCustomValueContainer: true,
  },
  {
    type: 'paymentDueFinance',
    key: 'payment_due_range',
    dependsOn: 'showDueRange',
  },
   {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
    className:'placeHolderText'
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  },
]

export const reconciliationFilters = (translations: any) => [
  {
    type: 'search',
    key: 'searchKeyword',
    placeholder: 'Search by Policy No, Customer Mobile or Insurance ID or Customer Name',
  },
  {
    type: 'createdOnDate',
    key: 'created_on',
  },
  {
    type: 'reconciliationStartDate',
    key: 'start_date',
    placeholder: 'Start Date',
  },
  {
    type: 'reconciliationEndDate',
    key: 'end_date',
    placeholder: 'End Date',
  },
  {
    type: 'select',
    key: 'attachment',
    optionsKey: 'attachmentFilterList',
    placeholder: 'Attachment',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'status',
    optionsKey: 'statusFilterList',
    placeholder: 'Status',
    useCustomValueContainer: true,
  }
];

export const reconciliationMoreFilters = (translations: any) => [
   {
    type: 'select',
    key: 'assignment_status',
    optionsKey: 'assigning_filters',
    placeholder: 'Assignment Status',
    useCustomValueContainer: true,
  },
  {
    type: 'select',
    key: 'assign_user_id',
    optionsKey: 'assign_user_id',
    placeholder: 'Assigned to',
    useCustomValueContainer: true,
    showWhen: {
      key: 'assignment_status',
      value: 1
    }
  }
];
